import request from '@/utils/request'

// 查询首页菜单列表
export function listMenu(query) {
  return request({
    url: '/web/menu/menulist',
    method: 'get',
    params: query
  })
}
// 查询banner
export function bannerList(query){
  return request({
    url: '/web/menu/bannerlist',
    method: 'get',
    params: query
  })

}